import styled from "styled-components";

export const Unit = styled.div`
    color: ${({ theme }) => theme.colors.tertiary[700]};
    font-size: 12px;
    display: ${(props) => (props.showUnit ? "block" : "none")};
`;
